// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container-3Effm"};